import collapsableEditing from './collapsable-editing';
import collapsableUI from './collapsable-ui';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class collapsable extends Plugin {
    static get requires() {
        return [ collapsableEditing, collapsableUI ];
    }
}